import React from "react";
import EmailVerificationPage from "./views/EmailVerificationPage";
import { EmailVerficationContextProvider } from "./EmailVerificationView";
import EmailVerficationContent from "../../constants/contentFile.json";
const EmailVerification = () => {
  return (
    <EmailVerficationContextProvider>
      <EmailVerificationPage
        textContants={EmailVerficationContent.pageEmailVerfication}
      />
    </EmailVerficationContextProvider>
  );
};
export default EmailVerification;
